// extracted by mini-css-extract-plugin
export default {"branchesTable":"ContestV2Panel_branchesTable__YZnU3"};